import type { InternalAxiosRequestConfig } from 'axios';
import posthog from 'posthog-js';

const POSTHOG_DISTINCT_ID_HEADER = 'X-POSTHOG-DISTINCT-ID';
const POSTHOG_SESSION_ID_HEADER = 'X-POSTHOG-SESSION-ID';

const isSameOriginRequest = (url?: string, baseURL?: string): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!url) {
        return true;
    }

    try {
        const requestUrl = new URL(url, baseURL ?? window.location.origin);

        return requestUrl.origin === window.location.origin;
    } catch {
        return false;
    }
};

export const attachPostHogCorrelationHeaders = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (!isSameOriginRequest(config.url, config.baseURL)) {
        return config;
    }

    const distinctId = posthog.get_distinct_id();
    const sessionId = posthog.get_session_id();

    if (typeof distinctId === 'string' && distinctId.trim() !== '') {
        config.headers.set(POSTHOG_DISTINCT_ID_HEADER, distinctId);
    }

    if (typeof sessionId === 'string' && sessionId.trim() !== '') {
        config.headers.set(POSTHOG_SESSION_ID_HEADER, sessionId);
    }

    return config;
};
